export class FrameChunk {
    constructor(
      readonly xStart: number,
      readonly yStart: number,
      readonly width: number,
      readonly height: number
    ) {

    }
}